<template>
  <div class="form-group">

    <date-picker v-model="featureProduct.feature_value"
                 format="YYYY-MM-DD"
                 display-format="dddd jDD jMMMM jYYYY"
                 auto-submit/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import DatePicker from "vue3-persian-datetime-picker";

export default defineComponent({
  name: "FeatureInputDate",
  components:{DatePicker},
  props: {
    featureProduct: {},
    product: {},
  }
})
</script>

<style scoped>

</style>